<template>
  <div class="receiptList">
    <el-form :model="searchData" ref="search">
      <QS-search maxLine="1" ref="BLM-search">
        <el-form-item prop="times" label="创建时间">
          <el-date-picker
            v-model="searchData.times"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="completeTime" label="完成日期">
          <el-date-picker
            v-model="searchData.completeTime"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="spId" label="关联网约平台">
          <el-select
            v-model="searchData.spId"
            clearable
            placeholder="请选择"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in spList"
              :label="item.spName"
              :value="item.spId"
              :key="item.spId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="licenceNo" label="收款主体">
          <el-select
            v-model="searchData.licenceNo"
            clearable
            placeholder="请选择"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in merchantList"
              :label="item.merchantName"
              :value="item.licenceNo"
              :key="item.licenceNo"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="discardTime" label="作废日期">
          <el-date-picker
            v-model="searchData.discardTime"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item prop="state" label="收款单状态">
          <el-select
            v-model="searchData.state"
            clearable
            placeholder="请选择收款单状态"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in stateList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="content" label="收款内容">
          <el-select
            v-model="searchData.content"
            clearable
            placeholder="请选择"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in freeTypeList"
              :label="item.name"
              :value="item.code"
              :key="item.code"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="carId" label="车牌号">
          <el-select
            v-model="searchData.carId"
            filterable
            remote
            reserve-keyword
            placeholder="请输入"
            clearable
            :remote-method="gerCarNoList"
            :loading="oLoading.carFuzzySearch"
            @change="handleCarNoChange"
          >
            <el-option
              v-for="item in carList"
              :key="item.id"
              :label="item.plateNo"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="'付款方类型'" prop="customerType">
          <el-select
            v-model="searchData.customerType"
            clearable
            placeholder="请选择"
            @change="changeCustomerType"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in payerList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="customerId" label="付款方">
          <el-select
            v-model="searchData.customerId"
            filterable
            :remote="searchData.customerType === 2"
            :remote-method="getPayCustomerList"
            :placeholder="
              (isCustomer && '请先选择付款方类型') || '请输入关键词'
            "
            clearable
            :loading="oLoading.customerFuzzySearch"
            :disabled="isCustomer"
          >
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.customerName"
              :value="item.id"
            >
              <CustomerNameOptionItem :data="item" />
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="batchReceivableId" label="收款ID">
          <el-input
            v-number:integer
            v-model="searchData.batchReceivableId"
            placeholder="请输入收款ID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="id" label="收款单ID">
          <el-input
            v-number:integer
            v-model="searchData.id"
            placeholder="请输入收款单ID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="receivableId" label="应收ID">
          <el-input
            v-number:integer
            v-model="searchData.receivableId"
            placeholder="请输入应收ID"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="支付方式" prop="payMethod">
          <el-select
            v-model="searchData.payMethod"
            clearable
            placeholder="请选择支付方式"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in payMethodList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="deptIdList" label="所属部门">
          <DeptSelect
            ref="deptSelectRef"
            v-model="searchData.deptIdList"
            multiple
            :isAll="false"
          />
        </el-form-item>

        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="oLoading.search"
              size="small"
              type="primary"
              @click="searchHandle"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset('search')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <PublicExport
              v-if="judgePermission('finance_receivable_receipt_excel')"
              exportTitle="收款单管理导出"
              exportTemplate="ReceivableOrder"
              :getSearchData="getSearchParams"
              templateCode="vehicle-receivable-order"
              :getSearchCondition="getSearchCondition"
            />
          </el-form-item>
        </template>
      </QS-search>
    </el-form>
    <el-alert
      title="在线支付收取的款项金额，会在收款后第二个自然日到账（扣除支付手续费）"
      type="info"
      show-icon
    ></el-alert>
    <OperationSummary
      title="当前筛选下收款情况"
      :summary="transData"
      :divideEqually="false"
      :loading="oLoading.search"
    ></OperationSummary>
    <QS-common-table
      :data="dataList"
      :columns="m_receiptListHead"
      :pagination="paginationData"
      @change="paginationChange"
    ></QS-common-table>

    <!-- 编辑弹窗 -->
    <dialogWrap
      v-model="detailsDialog.editShow"
      :title="'编辑'"
      :width="'824px'"
    >
      <AddReceipt
        v-if="detailsDialog.editShow"
        ref="editBill"
        :data="detailsDialog.data"
        :optionType="1"
        :type="2"
      ></AddReceipt>
      <template slot="footer">
        <el-button size="small" @click="cencelFn()">取消</el-button>
        <el-button
          :loading="oLoading.edit"
          size="small"
          type="primary"
          @click="editBillSubmit"
          >确认编辑</el-button
        >
      </template>
    </dialogWrap>

    <dialogWrap
      v-model="oShow.complete"
      title="提示"
      width="'560px'"
      custom-class="dialog-message"
    >
      <div class="mb-20">关闭后将作废收款单，应收单需要重新收款。</div>
      <div class="mb-20" v-if="!!oShow.completeText">
        {{ oShow.completeText }}
      </div>
      <div v-if="DingTalkShow20">
        <el-form
          ref="deleteReasonform"
          :model="deleteReasonform"
          label-width="120px"
          size="small"
          :rules="deleteReasonrules"
        >
          <el-form-item label="作废备注原因：" prop="discardReason">
            <el-input
              type="textarea"
              maxlength="1000"
              v-model="deleteReasonform.discardReason"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template slot="footer">
        <el-button size="small" @click="handleCancel">取消</el-button>
        <el-button
          :loading="oLoading.state"
          size="small"
          type="primary"
          v-submitDingTalkShow="20"
          @click="submitInvalidHandle"
          >确认</el-button
        >
      </template>
    </dialogWrap>
    <!-- 退款弹窗 -->
    <ReceiptRefund
      v-model="oShow.refund"
      :receiptItem="receiptItem"
      @postRefund="postRefund"
    ></ReceiptRefund>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import {
  editReceipt,
  getCollectCustomerList,
  getMerchantListAPI,
  getReceiptList,
  getSpListAPI,
  receivableReceiptCancel,
  receivableReceiptCancelCheck,
  receivableReceiptStatistic,
} from '@/api/financeApi'
import { FuzzySearch } from '@/api/purchaseAndSaleAPI'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import OperationSummary from '@/components/OperationSummary'
import { submitDingTalkShow } from '@/directives/submitDingTalkShow'
import AddReceipt from '@/pages/finance/addReceipt'
import ReceiptRefund from '@/pages/finance/components/ReceiptRefund.vue'
import { FEE_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import selectOption from '@/store/dict/selectOptionDict'
import { debounce, throttle } from '@/utils'
import { generateExportCondition } from '@/utils/exportUtils.js'
import { mapState } from 'vuex'
import receiptMixin from './mixins/index'

export default {
  props: {},
  components: {
    AddReceipt,
    ReceiptRefund,
    OperationSummary,
    CustomerNameOptionItem,
  },
  mixins: [receiptMixin],
  /** 钉钉审批流是否存在审批配置 2023/09/25 */
  directives: {
    submitDingTalkShow,
  },
  data() {
    return {
      DingTalkShow20: false,
      deleteReasonform: { discardReason: '' }, // 作废备注原因
      deleteReasonrules: {
        discardReason: [
          { required: true, message: '请填写作废备注原因', trigger: 'blur' },
        ],
      },
      Invalid: '',
      // eslint-disable-next-line vue/no-unused-properties
      categoryList: [], // 收款类目
      carList: [], // 模糊搜索车牌号
      oShow: {
        complete: false, // 作废弹窗
        completeText: '', // 作废弹窗-文案
        refund: false, // 退款弹窗
      },
      oLoading: {
        search: false,
        edit: false,
        carFuzzySearch: false,
      },
      searchData: {
        id: '',
        receivableId: '',
        times: [], // 创建日期
        completeTime: [], // 完成时间
        discardTime: [], // 作废时间
        state: '', // 收款状态
        content: '', // 收款内容
        carId: '', // 车牌号
        categoryCode: '', // 应收类目
        customerType: '', // 付款方类型
        customerId: '', // 付款方
        receivableType: '', // 收款账户
        payMethod: '', // 支付方式
        deptIdList: [],
        spId: '',
        licenceNo: '',
      },
      isCustomer: true, // 付款方是否可填写
      customerList: [], // 模糊搜索付款方
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      detailsDialog: {
        editShow: false,
        data: {},
      },
      dataList: [],
      transData: [],
      receiptItem: {}, // 操作退款收款单信息
      spList: [],
      merchantList: [],
      payerConditionList: [],
      plateNoConditionList: [],
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
    // 租金收款方式
    payMethodList() {
      return this.dictParseList(selectOption.payMethods)
    },
    // 收款单状态
    stateList() {
      return this.dictParseList(selectOption.moneyStateList)
    },
    // 付款方类型枚举
    payerList() {
      const result = {}
      for (const key in selectOption.customerTypeDict) {
        if (Object.hasOwnProperty.call(selectOption.customerTypeDict, key)) {
          if (Number(key) !== 10) {
            result[key] = selectOption.customerTypeDict[key]
          }
        }
      }
      return this.dictParseList(result)
    },
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    this.searchData.receivableId = this.$route.query.id

    // 设置创建日期、完成日期
    this.searchData.times = this.$route.query.times || []
    this.searchData.completeTime = this.$route.query.completeTime || []

    const { state, payMethod } = this.$route.query
    // 设置收款单状态
    this.searchData.state = state !== undefined && state !== ''
      ? Number(state)
      : ''

    // 设置支付方式
    this.searchData.payMethod = payMethod !== undefined && payMethod !== ''
      ? Number(payMethod)
      : ''
  },
  mounted() {
    this.getReceiptList()
    this.receivableReceiptStatistic()
    this.getMerchantList()
    this.getSpList()
  },
  activated() {
    this.triggerWindowResize()
  },
  watch: {
    'searchData.customerId': {
      handler() {
        this.payerConditionList = this.customerList
      },
    },
    'searchData.carId': {
      handler() {
        this.plateNoConditionList = this.carList
      },
    },
  },
  methods: {
    triggerWindowResize() {
      // 触发 resize 事件
      const resizeEvent = new Event('resize')
      window.dispatchEvent(resizeEvent)
    },
    handleCarNoChange(value) {
      !value && (this.carList = [])
    },
    // 付款方选中类型
    async changeCustomerType(val) {
      this.searchData.customerId = ''
      this.customerList = []
      // 类型为其他-付款方禁用，不可填写
      if (val === 3 || !val) {
        this.isCustomer = true
        return
      }

      this.isCustomer = false
      // 服务商
      if (val === 1) {
        getCollectCustomerList().then(({ code, data }) => {
          if (code === 1) {
            this.customerList = data.items.map((item) => ({
              ...item,
              customerName: item.name,
              customerTel: item.contactTel,
            }))
          }
        })
      }
    },
    // 模糊搜索获取付款方
    async getPayCustomerList(name) {
      if (Number(this.searchData.customerType) !== 2) return
      if (name.length < 1) return
      searchByCustomerNameSensitive({
        customerState: 1,
        customerName: name,
        mixedType: 'YES',
      }).then(({ code, data }) => {
        if (code === 1) {
          this.customerList = data
        }
      }).finally(() => {
        this.oLoading.customerFuzzySearch = false
      })
    },
    // 统计
    receivableReceiptStatistic() {
      receivableReceiptStatistic({
        ...this.getSearchParams(),
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.transData = [
            {
              subTitle: '收款中金额',
              numbers: data.receivingAmount,
              isThousandsSeparator: true,
              toolTip: '状态为「进行中」的收款单，收款金额汇总',
            },
            {
              subTitle: '已收金额',
              numbers: data.receivedAmount,
              isThousandsSeparator: true,
              toolTip: '状态为「已完成」的收款单，收款金额汇总',
            },
            {
              subTitle: '乾三收款中佣金',
              numbers: data.commissionReceivingAmount,
              isThousandsSeparator: true,
            },
            {
              subTitle: '乾三已收款佣金',
              numbers: data.commissionReceivedAmount,
              isThousandsSeparator: true,
            },
          ]
        }
      })
    },
    resetDeleteReasonForm() {
      if (this.DingTalkShow20) {
        this.deleteReasonform.discardReason = ''
        this.$refs?.deleteReasonform?.resetFields()
      }
    },
    // 取消弹窗
    handleCancel() {
      this.oShow.complete = false
      this.resetDeleteReasonForm()
    },
    // 作废确认
    submitInvalidHandle: throttle(async function () {
      if (this.DingTalkShow20) {
        const valid = await this.$refs?.deleteReasonform?.validate()
        if (!valid) {
          this.$message.warning('请填写作废原因！')
          return
        }
      }
      const { code } = await receivableReceiptCancel({
        id: this.Invalid,
        discardReason: this.deleteReasonform.discardReason,
      })
      if (code !== 1) return
      this.oShow.complete = false
      this.resetDeleteReasonForm()
      this.searchHandle()
      this.$message.success('操作成功')
    }, 1000),
    // 作废 ./mixins/index.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    async handleInvalid(row) {
      this.oShow.completeText = ''
      // 作废有滞纳金的款项的收款单时，增加文案提示
      // 是租金时
      if (row.content === FEE_CODE_MAP.ZU_JIN) {
        // 收款单作废前，先校验，获取提示信息
        const res = await receivableReceiptCancelCheck({ id: row.id })
        const { code, data } = res || {}
        if (code === 1 && data.pass === false) {
          this.oShow.completeText = data.failMsg
        }
      }
      this.oShow.complete = true
      this.Invalid = row.id
    },
    // 发起退款
    postRefund: debounce((receiptRefundData) => {
      console.log(receiptRefundData, 'receiptRefundData')
    }),
    // 模糊搜索获取车牌号
    async gerCarNoList(query) {
      // 开启远程搜索
      if (query.length >= 4) {
        this.oLoading.fuzzySearch = true
        try {
          const { code, data } = await FuzzySearch({
            plateNo: query,
            state: 1,
          })
          this.oLoading.fuzzySearch = false
          if (code === 1) {
            this.carList = data
          }
        } catch (error) {
          this.oLoading.fuzzySearch = false
        }
      }
    },
    // 获取请求参数
    getSearchParams() {
      let startDate = ''
      let endDate = ''
      let completeStartDate = ''
      let completeEndDate = ''
      let discardStartDate = ''
      let discardEndDate = ''
      if (this.searchData.times && this.searchData.times.length) {
        startDate = this.searchData.times[0]
        endDate = this.searchData.times[1]
      }
      if (this.searchData.completeTime && this.searchData.completeTime.length) {
        completeStartDate = this.searchData.completeTime[0]
        completeEndDate = this.searchData.completeTime[1]
      }

      if (this.searchData.discardTime && this.searchData.discardTime.length) {
        discardStartDate = this.searchData.discardTime[0]
        discardEndDate = this.searchData.discardTime[1]
      }

      return {
        ...this.searchData,
        startDate,
        endDate,
        completeStartDate,
        completeEndDate,
        discardStartDate,
        discardEndDate,
      }
    },

    // 请求列表
    async getReceiptList() {
      this.oLoading.search = true
      try {
        const { code, data } = await getReceiptList({
          ...this.getSearchParams(),
          pageNum: this.paginationData.pageNum,
          pageSize: this.paginationData.pageSize,
        })
        this.oLoading.search = false
        if (code === 1) {
          this.dataList = data.items
          this.paginationData.total = data.totalNum
        }
      } catch (error) {
        this.oLoading.search = false
      }
    },

    // 获取收款主体列表
    async getMerchantList() {
      const { code, data } = await getMerchantListAPI()
      if (code === 1) {
        this.merchantList = data
      }
    },

    // 获取网约SP列表
    async getSpList() {
      const { code, data } = await getSpListAPI()
      if (code === 1) {
        this.spList = data
      }
    },

    searchHandle() {
      this.paginationData.pageNum = 1
      const para = {
        pagination: this.paginationData,
      }
      this.paginationChange(para)
    },

    // 查看详情 ./mixins/index.js有引用
    // eslint-disable-next-line vue/no-unused-properties
    viewDetails(id) {
      this.$router.push({
        path: '/finance/receiptList/detail',
        query: {
          id,
        },
      })
    },
    // 编辑收款单
    editBillSubmit() {
      this.$refs.editBill.formValidate().then((data) => {
        this.oLoading.edit = true
        editReceipt(data)
          .then(({ code }) => {
            this.oLoading.edit = false
            if (code === 1) {
              this.$message.success('操作成功')
              this.getReceiptList()
              this.detailsDialog.editShow = false
            }
          })
          .catch(() => {
            this.oLoading.edit = false
          })
      })
    },

    // 取消按钮操作
    cencelFn() {
      this.$refs.editBill.formResetFields()
      this.detailsDialog.editShow = false
    },
    // 重置
    reset(from) {
      this.$refs[from].resetFields()
      this.paginationData.pageNum = 1
      this.paginationData.pageSize = 10
      this.getReceiptList()
      this.receivableReceiptStatistic()
      this.isCustomer = true
      this.carList = []
    },
    // 分页事件
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getReceiptList()
      this.receivableReceiptStatistic()
    },
    // 获取异步导出参数展示
    getSearchCondition() {
      const formConfig = [{
        el: 'date-picker',
        itemConfig: {
          label: '创建日期',
          prop: 'times',
        },
      }, {
        el: 'date-picker',
        itemConfig: {
          label: '完成日期',
          prop: 'completeTime',
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '关联网约平台',
          prop: 'spId',
        },
        elConfig: {
          options: {
            list: this.spList,
            value: 'spId',
            label: 'spName',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '收款主体',
          prop: 'licenceNo',
        },
        elConfig: {
          options: {
            list: this.merchantList,
            value: 'licenceNo',
            label: 'merchantName',
          },
        },
      }, {
        el: 'date-picker',
        itemConfig: {
          label: '作废日期',
          prop: 'discardTime',
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '收款单状态',
          prop: 'state',
        },
        elConfig: {
          options: {
            list: this.stateList,
            value: 'value',
            label: 'label',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '收款内容',
          prop: 'content',
        },
        elConfig: {
          options: {
            list: this.freeTypeList,
            value: 'code',
            label: 'name',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '车牌号',
          prop: 'carId',
        },
        elConfig: {
          options: {
            list: this.plateNoConditionList,
            value: 'id',
            label: 'plateNo',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '付款方类型',
          prop: 'customerType',
        },
        elConfig: {
          options: {
            list: this.payerList,
            value: 'value',
            label: 'label',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '付款方',
          prop: 'customerId',
        },
        elConfig: {
          options: {
            list: this.payerConditionList,
            value: 'id',
            label: 'customerName',
          },
        },
      }, {
        el: 'input',
        itemConfig: {
          label: '收款ID',
          prop: 'batchReceivableId',
        },
      }, {
        el: 'input',
        itemConfig: {
          label: '收款单ID',
          prop: 'id',
        },
      }, {
        el: 'input',
        itemConfig: {
          label: '应收ID',
          prop: 'receivableId',
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '支付方式',
          prop: 'payMethod',
        },
        elConfig: {
          options: {
            list: this.payMethodList,
            value: 'value',
            label: 'label',
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '所属部门',
          prop: 'deptIdList',
        },
        elConfig: {
          options: {
            list: this.$refs.deptSelectRef.flatOptions(),
            value: 'id',
            label: 'name',
          },
        },
      }]
      return formConfig.map((item) => {
        const { el, itemConfig: { label, prop: key } } = item
        const val = this.searchData[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.search-box {
  overflow: hidden;
  .el-input {
    width: 240px;
  }
  .el-select {
    width: 240px;
  }
  .search-btns {
    padding-left: 150px;
  }
  background-color: #f7f8fa;
}
.pagination {
  height: 60px;
}

.operation-box {
  display: flex;
  justify-content: flex-end;
  align-content: center;
  padding-top: 16px;
}

.customer {
  display: flex;
  flex-direction: row;
  &-name {
    // float: left;
    width: 80px;
    height: 35px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
  }
  &-phone {
    // float: left;
    color: #8492a6;
    font-size: 13px;
    margin: 0;
    padding-left: 20px;
  }
}
</style>
